
import Animation from 'Scripts/classes/Animation'
//Vendor
import gsap from 'gsap'

export default class extends Animation {
  constructor({ element }) {
    // console.log(element)
    super({
      element
    })
  }

  animateIn() {
    super.animateIn()

    gsap.to(this.element, {
      autoAlpha: 1,
      y: 0,
      duration : 1
    })
  }

  animateOut() {
    super.animateOut()

    gsap.set(this.element, {
      autoAlpha: 0,
      y: 100
    })
  }

}
